import React, { useState } from 'react';
import { Accordion } from 'anf-core-react';
import { TmntText } from '../../Common';
import { nextStepsProps } from './props';
import StepTitle from './StepTitle';
import StepTwoContent from './StepTwoContent';
import StepFourContent from './StepFourContent';

export default function NextSteps({ nextSteps }) {
  const {
    title, stepOne, stepTwo, stepThree, stepFour,
  } = nextSteps;
  const [accordionPanel, setAccordionPanel] = useState(2);
  const exclusiveToggle = (aNumber) => () => {
    setAccordionPanel((prev) => (prev === aNumber ? 0 : aNumber));
  };

  const isCancelled = stepTwo.title.value === 'cancelled';

  return (
    <div className="accordion-group">
      <h2 className="h3" data-testid="next-steps-title">
        <TmntText tmnt={title} />
      </h2>
      <Accordion
        headingLevel={4}
        id="rne-nextsteps-stepone-accordion"
        isExpanded={false}
        onClick={exclusiveToggle(1)}
        title={<StepTitle stepNumber="1" title={stepOne} />}
        variant="bordered"
      >
        <span />
      </Accordion>
      {/* Display step two as plain text for cancelled RNE Orders */}
      <Accordion
        headingLevel={4}
        id={isCancelled ? 'rne-nextsteps-steptwo-rneCancelled' : 'rne-nextsteps-steptwo-accordion'}
        isExpanded={!isCancelled && accordionPanel === 2}
        onClick={exclusiveToggle(2)}
        title={<StepTitle stepNumber="2" title={stepTwo.title} />}
        variant="bordered"
      >
        <StepTwoContent stepTwo={stepTwo} />
      </Accordion>
      {stepThree && (
        <Accordion
          headingLevel={4}
          id="rne-nextsteps-stepthree-accordion"
          isExpanded={false}
          onClick={exclusiveToggle(3)}
          title={<StepTitle stepNumber="3" title={stepThree} />}
          variant="bordered"
        >
          <span />
        </Accordion>
      )}
      {stepFour && (
        <Accordion
          headingLevel={4}
          id="rne-nextsteps-stepfour-accordion"
          isExpanded={accordionPanel === 4}
          onClick={exclusiveToggle(4)}
          title={(
            <StepTitle
              stepNumber={stepThree ? '4' : '3'}
              title={stepFour.title}
            />
          )}
          variant="bordered"
        >
          <StepFourContent stepFour={stepFour} />
        </Accordion>
      )}
    </div>
  );
}

NextSteps.propTypes = nextStepsProps;
